import React from "react";
import { FiLogOut, FiMenu, FiBell } from "react-icons/fi";
import logo from "../assets/logo.png";

const Navbar = ({
  user,
  onLogout,
  onSelectMenu,
  onToggleSidebar,
  onGoHome, // ✅ handler klik logo
  isMobile,
}) => {
  return (
    <div
      style={{
        background: "#1e293b",
        color: "#faf9f9",
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        position: "sticky",
        top: 0,
        zIndex: 1500,
      }}
    >
      <div
        style={{
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* === Kiri: Logo + Menu button === */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {isMobile && (
            <button
              onClick={onToggleSidebar}
              style={{
                background: "transparent",
                border: "none",
                color: "#fff",
                fontSize: "22px",
                cursor: "pointer",
              }}
            >
              <FiMenu />
            </button>
          )}

          {/* ✅ Klik logo kembali ke /dashboard */}
          <img
            src={logo}
            alt="Logo"
            onClick={onGoHome}
            style={{
              height: "30px",
              cursor: "pointer",
              transition: "transform 0.2s ease",
            }}
            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        </div>

        {/* === Kanan: User info + Notification + Logout === */}
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          {!isMobile && (
            <div style={{ textAlign: "right", lineHeight: "1.2" }}>
              <div style={{ fontWeight: "500" }}>
                {user?.name || "User"}
              </div>
              <div style={{ fontSize: "0.85rem", color: "#cbd5e1" }}>
                {user?.jabatan || "Jabatan"}
              </div>
            </div>
          )}

          {/* 🔔 Notifikasi */}
          <FiBell
            title="Notifikasi"
            size={20}
            color="#fff"
            style={{
              cursor: "pointer",
              transition: "transform 0.2s ease",
            }}
            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            onClick={() => alert("Belum ada notifikasi 😄")}
          />

          {/* 🚪 Logout */}
          <FiLogOut
            onClick={onLogout}
            title="Logout"
            size={22}
            color="#fff"
            style={{
              cursor: "pointer",
              transition: "transform 0.2s ease",
            }}
            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
